import type { BuildingEntityBase } from "building-types/entities/buildingEntityBase";
import type { BuildingEntityHandle } from "building-types/entities/buildingEntityHandle";
import type { DocEntityHandle, LevelHandle, RoomHandle } from "building-types/handles/docEntityHandleTypes";
import type { RoomCondition } from "building-types/rooms/roomTypesEnum";
import type { WallAssemblyStructuralLayer } from "building-types/walls/wallAssemblyTypes";
import type { WallCondition } from "building-types/walls/wallType";
import type { InchesSquared, WorldInches } from "common/types/nominalNumbersTypes";
import type { Plane } from "geom/planeTypes";
import type { PolyLine2 } from "geom/polyLine2Types";

export const DOMAIN_COLOR = 0xddbbee;

export const DOMAIN_EDGE_COLOR = 0xaa99bb;

export interface WallStructuralDomain extends BuildingEntityBase<"WALL_STRUCTURAL_DOMAIN"> {
  readonly id: string;
  readonly resolvedBoundary: PolyLine2;
  readonly plane: Plane;
  readonly name: string;
  readonly parentHandles: (BuildingEntityHandle | DocEntityHandle)[];
  readonly layers: WallAssemblyStructuralLayer[];
  readonly leftRooms: RoomHandle[];
  readonly rightRooms: RoomHandle[];
  readonly height: WorldInches;
  readonly length: WorldInches;
  readonly area: InchesSquared;
  readonly isRectangular: boolean;
  readonly color: number;
  readonly condition: WallCondition;
  readonly leftRoomCondition: RoomCondition;
  readonly rightRoomCondition: RoomCondition;
  readonly levelIndex: number;
  readonly bottomGeneratingLevel: LevelHandle | undefined;
}
